import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { Catalog } from '../../../../Model/Catalog/Catalog';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { Macro } from 'app/Model/ui/Macro';

@Component({
    selector: 'userAction-compareCatalog',
    templateUrl: 'userAction-compareCatalog.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionCompareCatalogComponent) }
    ],
    standalone: false
})
export class UserActionCompareCatalogComponent extends UserActionBaseComponent {

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.catalogService
      .getCatalogs(this.loginService.currentUser.customerId)
      .subscribe((result: Catalog[]) => {
        this.catalogs = result.filter((c) => !c.isVirtual);
      });
  }

  _sourceCompareCatalog: string = '';
  useEanAsKey: boolean = false;
  catalogs: Catalog[];

  get sourceCompareCatalog(): string {
    return this._sourceCompareCatalog;
  }

  set sourceCompareCatalog(sourceCompareCatalog: string) {
    this._sourceCompareCatalog = sourceCompareCatalog;
  }

  async canStartMacro() : Promise<boolean> {
    if (this.sourceCompareCatalog == '') {
      this.systemService.notifyWarning('Bitte Katalog auswählen.');
      return false;
    }
    if (this.sourceCompareCatalog == this.catalogService.catalog.id) {
      this.systemService.notifyWarning('Katalog kann nicht mit sich selbst verglichen werden.');
      return false;
    }

    return true;
  }

  public getActionId(macro: Macro): string {
    return `CompareCatalog(${this.sourceCompareCatalog}:${this.useEanAsKey})`;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({sourceCompareCatalog:this.sourceCompareCatalog, useEanAsKey: this.useEanAsKey });
  }
  public parseParameter(parameter: string) {
    throw new Error('Method not implemented.');
  }
}
